import * as React from 'react';
import { cn } from '../../utils';

export interface LogoProps extends React.HTMLAttributes<HTMLSpanElement> {
  /**
   * Any CSS length — the wordmark's font size. Applied inline rather than as a
   * Tailwind class because `.ba-wordmark` (globals.css) is unlayered and would
   * beat an arbitrary-property utility such as `[--ba-wordmark-base:4rem]`.
   */
  size?: string;
}

/**
 * The Bill Alps wordmark: handwritten "Bill Alps" in Yellowtail, brand blue.
 * Typography lives in `.ba-wordmark` (packages/ui/globals.css) — the same rules
 * the website's Logo.astro uses, so both surfaces stay in step.
 */
const Logo = React.forwardRef<HTMLSpanElement, LogoProps>(
  ({ className, size = '2rem', style, ...props }, ref) => (
    <span
      ref={ref}
      className={cn('ba-wordmark', className)}
      style={{ ['--ba-wordmark-base' as string]: size, ...style }}
      {...props}
    >
      Bill Alps
    </span>
  ),
);
Logo.displayName = 'Logo';

export { Logo };
